import React, { useEffect, useState } from "react";
import { get, isEmpty } from 'lodash';
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import Step from "./Step/Step";
import ConfirmDetails from "./Step/ConfirmDetails";
import PersonalDetails from "./Step/PersonalDetails";
import Discounts from "../../../components/MemberForm/Discounts";
import PaymentForm from "../../../components/MemberForm/PaymentForm";
import Congratulations from "../../../components/MemberForm/Congratulations";

import style from "./style.module.css";

export default function Reactivation(props) {

    const userProfile = useSelector((state) => state.storage.data);
    const navigate = useNavigate();
    const Params = useParams();
    const urlhash = get(Params, "hash", "");

    useEffect(() => {
        if (isEmpty(urlhash)) {
            navigate('/home');
        }
        else if (isEmpty(userProfile)) {
            navigate(`/sign-in?redirect=/reactivation/${urlhash}`);
        }
    }, [userProfile, navigate, urlhash]);

    const [step, setStep] = useState("PersonalDetails");
    const [personalDetails, setPersonalDetails] = useState({});
    const [planId, setPlanId] = useState();
    const [planType, setPlanType] = useState();
    const [couponId, setCouponId] = useState(null);
    const [paymentIntentDetails, setPaymentIntentDetails] = useState({});
    const [autoRenewal, setAutorenewal] = useState(1);
    const [total, setTotal] = useState("0");
    const [originalTotal, setOriginalTotal] = useState("0");
    const [urlHash, setUrlHash] = useState(urlhash);
    const totalStep = "05";

    return (
        <div className={style.register}>
            {
                step === "PersonalDetails" && (
                    <Step
                        currentStep="01"
                        back={false}
                        totalStep={totalStep}
                        image={props.step_one_bg_image}
                        title={props.step_one_title}
                        text={props.step_one_description}
                        userProfile={userProfile}
                    >
                        <PersonalDetails
                            nextStep={setStep}
                            personalDetails={userProfile}
                            setPersonalDetails={setPersonalDetails}
                            showPlanList={props.show_plan_list}
                            setPlanId={setPlanId}
                            setPlanType={setPlanType}
                            setUrlHash={setUrlHash}
                            urlHash={urlHash}
                        />
                    </Step>
                )
            }
            {
                step === "ConfirmDetails" && (
                    <Step
                        currentStep="02"
                        back={false}
                        totalStep={totalStep}
                        image={props.step_two_bg_image}
                        title={props.step_two_title}
                        text={props.step_two_description}
                    >
                        <ConfirmDetails
                            personalDetails={personalDetails}
                            setPersonalDetails={setPersonalDetails}
                            nextStep={setStep}
                            planType={planType}
                            planId={planId}
                        />
                    </Step>
                )
            }
            {
                step === "Discounts" && (
                    <Step
                        currentStep="03"
                        back={false}
                        totalStep={totalStep}
                        image={props.step_three_bg_image}
                        title={props.step_three_title}
                        text={props.step_three_description}
                    >
                        <Discounts
                            personalDetails={personalDetails}
                            setPaymentIntentDetails={setPaymentIntentDetails}
                            nextStep={setStep}
                            planId={planId}
                            setTotal={setTotal}
                            total={total}
                            setOriginalTotal={setOriginalTotal}
                            originalTotal={originalTotal}
                            setCouponId={setCouponId}
                            setAutorenewal={setAutorenewal}
                            paymentIntentUrl="/payment/reactive-payment-intent"
                        />
                    </Step>
                )
            }
            {
                step === "PaymentForm" && (
                    <Step
                        currentStep="04"
                        back={false}
                        totalStep={totalStep}
                        image={props.step_four_bg_image}
                        title={props.step_four_title}
                        text={props.step_four_description}
                    >
                        <PaymentForm
                            paymentIntentDetails={paymentIntentDetails}
                            personalDetails={personalDetails}
                            planId={planId}
                            planType={planType}
                            total={total}
                            couponId={couponId}
                            nextStep={setStep}
                            from="reactive"
                            autoRenewal={autoRenewal}
                        />
                    </Step>
                )
            }
            {
                step === "Congratulations" && (
                    <Step
                        currentStep="05"
                        back={false}
                        totalStep={totalStep}
                        image={props.step_five_bg_image}
                        title={props.step_five_title}
                        text={props.step_five_description}
                        stepName="congratulations"
                    >
                        <Congratulations
                            nextStep={"home"}
                        />
                    </Step>
                )
            }
        </div>
    )
}